import type { CampaignTypeT } from "@/app/types/campaigns";

/**
 * Extract label strings from campaign types array
 *
 * @param campaignTypes - Array of campaign types
 * @returns Array of campaign type labels
 *
 * @example
 * ```tsx
 * const displayTypes = getCampaignTypeLabels(campaign.campaign_types);
 * ```
 */
export function getCampaignTypeLabels(
  campaignTypes: CampaignTypeT[] | null | undefined
): string[] {
  return campaignTypes?.map((type) => type.label) || [];
}
